import React from "react";
import { motion } from "framer-motion";
import { useT } from "../i18n/LanguageContext";

const ROOM_IMG =
  "https://static.prod-images.emergentagent.com/jobs/3f20d01d-d5e0-46a1-b467-01c97ab78497/images/188c5c55d7b18c0fa0bcf3297191c7eb10bf0b64f8a9aaa420f50df436bf38be.png";

export default function HowItWorks() {
  const { t } = useT();
  const STEPS = ["01", "02", "03"].map((n, i) => ({
    n,
    title: t(`how.s${i + 1}.title`),
    text: t(`how.s${i + 1}.text`),
  }));
  return (
    <section
      id="how-it-works"
      data-testid="how-it-works-section"
      className="py-24 sm:py-32 bg-[#F8F7F3]"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="lg:col-span-5"
          >
            <div className="text-xs uppercase tracking-[0.25em] text-[#899480] font-semibold mb-4">
              {t("how.eyebrow")}
            </div>
            <h2 className="font-serif text-4xl sm:text-5xl font-light leading-[1.05] text-[#3F5043] mb-7">
              {t("how.title.a")} <em className="text-[#875F45]">{t("how.title.em")}</em>{" "}
              {t("how.title.b")}
            </h2>
            <div className="relative aspect-[4/3] rounded-[2rem] overflow-hidden">
              <img
                src={ROOM_IMG}
                alt="Warm, inviting consultation room"
                className="w-full h-full object-cover"
              />
            </div>
          </motion.div>

          <div className="lg:col-span-7 lg:pt-6">
            <ol className="space-y-10">
              {STEPS.map((s, i) => (
                <motion.li
                  key={s.n}
                  data-testid={`step-${i + 1}`}
                  initial={{ opacity: 0, y: 22 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.6, delay: i * 0.1 }}
                  className="grid grid-cols-12 gap-5 pb-10 border-b border-[#BCB3A6]/40 last:border-0 last:pb-0"
                >
                  <div className="col-span-3 sm:col-span-2">
                    <div className="font-serif text-5xl sm:text-6xl text-[#875F45] leading-none">
                      {s.n}
                    </div>
                  </div>
                  <div className="col-span-9 sm:col-span-10">
                    <h3 className="font-serif text-2xl sm:text-3xl text-[#3F5043] mb-2">
                      {s.title}
                    </h3>
                    <p className="text-base sm:text-lg leading-relaxed text-[#3F5043]/75 max-w-xl">
                      {s.text}
                    </p>
                  </div>
                </motion.li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}
